import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  notification: [],
  category: [],
  notificationDiv: false

};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotificationData: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearNotification: (state) => {
      return initialState;
    },
  },
});

export const { setNotificationData, clearNotification } = notificationSlice.actions;
export default notificationSlice.reducer;

